import Utils from "../utils/Utils";

const userController = {
  authenticateUser: ({ authenticationDTO }) => {
    return Utils.controller(
      process.env.REACT_APP_AUTHENTICAT_USER_API,
      authenticationDTO,
      "POST",
      "",
      false,
      "",
      true,
    );
  },

  enrollMfa: ({ mfaDTO, jwt }) => {
    return Utils.controller(
      "api/mfa/v1/mfa/enrollMfa",
      mfaDTO,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },

  verifyMFA: ({ mfaDTO, jwt }) => {
    return Utils.controller(
      "api/mfa/v1/mfa/confirmMfa",
      mfaDTO,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },
  ResetMfa: (resetMfaDTO, jwt) => {
    return Utils.controller(
      "api/user/v1/resetMfa",
      resetMfaDTO,
      "PUT",
      "",
      true,
      jwt,
      true,
    );
  },

  registerUser: ({ UserRegisterDTO }) => {
    return Utils.controller(
      "api/user/v1/authenticate/register",
      UserRegisterDTO,
      "POST",
      "",
      false,
      "",
      true,
    );
  },
  checkIfEmailInUse: ({ email }) => {
    return Utils.controller(
      "api/user/v1/checkIfEmailInUse",
      "",
      "GET",
      "Email=" + email,
      false,
      "",
      true,
    );
  },
  sendEmailOtp: ({ email, otpEmailSubject }) => {
    return Utils.controller(
      "api/user/v1/authenticate/sendOtp",
      {},
      "GET",
      `email=${email}&otpEmailSubject=${otpEmailSubject}`,
      false,
      "",
      true,
    );
  },
  GetRoles: ({ application, companyId, jwt }) => {
    return Utils.controller(
      "api/roles/v1/getAllRoles",
      "",
      "GET",
      `companyId=${companyId}&application=${application}`,
      true,
      jwt,
      true,
    );
  },
  AddRole: ({ addRole, jwt }) => {
    return Utils.controller(
      "api/roles/v1/AddRole",
      addRole,
      "POST",
      "",
      true,
      jwt,
      true,
    );
  },
  deleteRole: ({ deleteRoleRequest, jwt }) => {
    return Utils.controller(
      "api/roles/v1/deleteRole",
      deleteRoleRequest,
      "DELETE",
      "",
      true,
      jwt,
      true,
    );
  },
  GetAllPermission: ({ application, jwt }) => {
    return Utils.controller(
      "api/permissions/v1/getAllPermission",
      "",
      "GET",
      `application=${application || ""}`,
      true,
      jwt,
      true,
    );
  },
  getUser: ({ Authorization, Jwt, jwt, UserJWT, userID } = {}) => {
    const params = new URLSearchParams();
    if (userID) params.append("userID", userID);

    return Utils.controller(
      "api/user/v1/user",
      "",
      "GET",
      params.toString(),
      true,
      Authorization || Jwt || jwt || UserJWT || "",
      true,
    );
  },

  verifyEmailOtp: ({ verifyOtpDTO }) => {
    return Utils.controller(
      "api/user/v1/authenticate/verifyEmailOTP",
      verifyOtpDTO,
      "POST",
      "",
      false,
      "",
      true,
    );
  },
  sendEmailOtp: ({ email, otpEmailSubject }) => {
    return Utils.controller(
      "api/user/v1/authenticate/sendOtp",
      {},
      "GET",
      `email=${email}&otpEmailSubject=${otpEmailSubject}`,
      false,
      "",
      true,
    );
  },
  forgetpassword: ({ source, value }) => {
    return Utils.controller(
      "api/user/v1/authenticate/forgetPassword",
      {},
      "GET",
      `source=${source}&value=${value}`,
      false,
      "",
      true,
    );
  },
  setPassword: ({ setPasswordDTO }) => {
    return Utils.controller(
      "api/user/v1/authenticate/setPassword",
      setPasswordDTO,
      "POST",
      "",
      false,
      "",
      true,
    );
  },
};
export default userController;
